import { useTranslation } from "react-i18next";

import { useErrorCodeMap } from "libs/react-query/hooks/useErrorCodeMap";

import type { MappedError } from "@becon-team/becon-fe-lib/my-axios";

export const useUserErrorCodeMap: () => Record<string, MappedError> = () => {
  const errorCodeMap = useErrorCodeMap();
  const { t } = useTranslation();

  return {
    ...errorCodeMap,
    NOT_FOUND: {
      message: t("존재하지 않는 고객이에요."),
    },
    WEATHER_UNAVAILABLE: {
      type: "NOT_NOTIFY",
    },
  };
};
